import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FileSignature, ArrowRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageLoading, EmptyState, fmtDate } from "@/components/shared";
import api from "@/lib/api";

const prettify = (s) => (s || "").replace(/_/g, " ").toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
const STATUSES = ["DRAFT", "DATA_INCOMPLETE", "READY_TO_GENERATE", "GENERATED", "SIGNED", "ACTIVE", "SUPERSEDED", "CANCELLED"];

export default function Contracts() {
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [status, setStatus] = useState("ALL");
  useEffect(() => {
    const p = new URLSearchParams();
    if (status !== "ALL") p.set("status", status);
    api.get(`/employer/contracts?${p}`).then((r) => setRows(r.data.contracts)).catch(() => setRows([]));
  }, [status]);

  return (
    <div data-testid="contracts-page">
      <div className="mb-6 flex items-center gap-3">
        <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-cyan/10 text-cyan-dark"><FileSignature className="h-5 w-5" /></span>
        <div><h1 className="font-heading text-2xl font-extrabold text-navy sm:text-3xl">Arbeitsverträge</h1><p className="text-sm text-slate-500">Strukturierte Vertragserstellung mit EmployGuard AI.</p></div>
      </div>
      <div className="mb-4">
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="w-56" data-testid="contracts-filter"><SelectValue /></SelectTrigger>
          <SelectContent><SelectItem value="ALL">Alle Status</SelectItem>{STATUSES.map((s) => <SelectItem key={s} value={s}>{prettify(s)}</SelectItem>)}</SelectContent>
        </Select>
      </div>
      {rows === null ? <PageLoading /> : rows.length === 0 ? <EmptyState icon={FileSignature} title="Noch keine Verträge" subtitle="Erstellen Sie einen Vertrag aus dem Mitarbeiterprofil." /> : (
        <div className="overflow-x-auto rounded-2xl border border-slate-200 bg-white">
          <table className="w-full text-sm" data-testid="contracts-table">
            <thead className="border-b border-slate-200 bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-400">
              <tr><th className="px-4 py-3">Mitarbeiter</th><th className="px-4 py-3">Position</th><th className="px-4 py-3">Beginn</th><th className="px-4 py-3">Version</th><th className="px-4 py-3">Status</th><th className="px-4 py-3" /></tr>
            </thead>
            <tbody>
              {rows.map((c) => (
                <tr key={c.id} className="cursor-pointer border-b border-slate-50 hover:bg-slate-50" onClick={() => nav(`/app/employer/contracts/${c.id}`)} data-testid={`contract-${c.id}`}>
                  <td className="px-4 py-3 font-semibold text-navy">{c.worker_name}</td>
                  <td className="px-4 py-3 text-slate-600">{c.data?.job_title || c.prefill?.job_title || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">{c.data?.start_date || "—"}</td>
                  <td className="px-4 py-3 text-slate-600">v{c.version}</td>
                  <td className="px-4 py-3"><span className="rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-[11px] font-semibold text-slate-600">{prettify(c.status)}</span></td>
                  <td className="px-4 py-3 text-right"><ArrowRight className="ml-auto h-4 w-4 text-slate-400" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
